export enum EntityType {
  Private = 'private',
  Public = 'public',
}
